import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
import React from 'react'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../../common/button'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  image: string
  imageAltText: string
  imageEnabled: boolean
  textOne: string
  textTwo: string
  textAlignment: Alignment
  buttonProp: LinkButtonProp
  heroFooterBackground: string
  heroFooterBackgroundMobile: string
  roundedBorder: boolean
}

const BlogTextImageCta = ({
  backgroundColor,
  image,
  imageAltText,
  imageEnabled,
  textOne,
  textTwo,
  textAlignment,
  buttonProp,
  heroFooterBackground,
  heroFooterBackgroundMobile,
  roundedBorder
}: Props) => {
  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const textAlignClass = getAlignmentClass()

  return (
    <div className={`flex flex-col w-full items-center mx-auto max-w-[500px] lg:max-w-none`}>
      <div
        className={`${roundedBorder ? (heroFooterBackground ? 'rounded-t-2xl' : 'rounded-2xl') : 'rounded-none'} p-4 pb-8`}
        style={{ backgroundColor: backgroundColor }}
      >
        {imageEnabled && (
          <CdnImage className="relative mx-auto h-auto object-cover w-full pb-4" url={image} alt={imageAltText} />
        )}

        {textOne && (
          <div
            className={`${textAlignClass} ${textTwo ? 'pb-6' : 'pb-2'} flex mx-auto items-center`}
            dangerouslySetInnerHTML={{ __html: textOne }}
          />
        )}
        {textTwo && (
          <div
            className={`${textAlignClass} flex mx-auto items-center`}
            dangerouslySetInnerHTML={{ __html: textTwo }}
          />
        )}

        <div className="flex w-full">
          {buttonProp && (
            <LinkButton
              buttonColor={buttonProp.buttonColor}
              buttonText={`${buttonProp.buttonText} `}
              loggedInButtonText={buttonProp.loggedInButtonText}
              buttonTextColor={buttonProp.buttonTextColor}
              buttonUrl={buttonProp.buttonUrl}
              isLink={buttonProp.isLink}
              classList={
                'inline-flex items-center justify-center w-full mx-auto sm:w-2/3 md:w-4/5 px-5 py-3 text-base font-medium rounded-full text-white mt-4 border border-[#006685]'
              }
            />
          )}
        </div>
      </div>

      {heroFooterBackground && (
        <div
          className={`relative hidden builderBreak:block h-12 w-full bg-contain 2xl:bg-cover bg-no-repeat mt-[-1px] mx-auto items-center max-w-[605px]`}
          style={{ backgroundImage: heroFooterBackground ? `url(${heroFooterBackground})` : 'none' }}
        ></div>
      )}
      {heroFooterBackgroundMobile && (
        <div
          className="relative block h-16 bg-contain builderBreak:hidden bg-no-repeat w-full mt-[-1px] mx-auto items-center max-w-[500px]"
          style={{ backgroundImage: heroFooterBackgroundMobile ? `url(${heroFooterBackgroundMobile})` : 'none' }}
        ></div>
      )}
    </div>
  )
}

export default BlogTextImageCta

Builder.registerComponent(BlogTextImageCta, {
  name: 'BlogTextImageCta',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'textOne',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textTwo',
      type: 'richText',
      defaultValue: ''
    },

    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'heroFooterBackground',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'heroFooterBackgroundMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'roundedBorder',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
